import api from './api';

export const goalService = {
  getAll: async () => api.get('/goals'),
  getById: async (goalId) => api.get(`/goals/${goalId}`),
  create: async (data) => api.post('/goals', data),
  update: async (goalId, data) => api.put(`/goals/${goalId}`, data),
  delete: async (goalId) => api.delete(`/goals/${goalId}`),
  addContribution: async (goalId, data) => api.post(`/goals/${goalId}/contributions`, data),
};
